import "./FeedbackContainer.css";

const FeedbackContainer = () => {
  return (
    <div className="modern-feedback-container">
      <h3 className="modern-feedback-title">
        Feedback for hotel
      </h3>
      <textarea
        placeholder="Tell us about your stay or leave feedback for the housekeeper"
        className="modern-feedback-textarea"
      ></textarea>
    </div>
  );
};

export default FeedbackContainer;
